/**
 * Build labels (in `labels.prefers`) naming the people whose work a build
 * belongs to: the commit author, the pull request author, and the user who
 * triggered it manually from the UI/API.
 */
export const USER_WORK_LABELS = [
    'git.author.email',
    'pull_request.author.email',
    'trigger.user.email',
];
/**
 * Normalize an email for comparison (git and OIDC emails often differ in case)
 */
export function normalizeEmail(email) {
    return email.trim().toLowerCase();
}
/**
 * Whether a build belongs to the work of the user with the given email
 */
export function isUserBuild(build, email) {
    const target = normalizeEmail(email);
    if (!target)
        return false;
    const prefers = build.labels?.prefers ?? {};
    return USER_WORK_LABELS.some((key) => {
        const value = prefers[key];
        return value !== undefined && normalizeEmail(value) === target;
    });
}
//# sourceMappingURL=ownership.js.map